// @flow

import _ from 'lodash';
import I18n from 'PMT/i18n/I18n'

import {
  SessionStore,
  ProAccountStore,
  RestaurantStore
} from 'stores';

import { SessionAction, RouteAction } from 'actions';
import RoutingEnum from 'constants/RoutingEnum';
import { Config } from 'constants';
import { Logger, UrlUtils } from 'PMT/utils';

/**
 * Returns the user credentials for the 'Authorization' header.
 * @returns {string}
 */
function getAuthorizationHeader(): string {
  return SessionStore.getAuthorization();
}

function getApiKey(): string {
  return `Basic ${Config.apikey}`;
}

function getSelectedProDomainId() {
  const domain = ProAccountStore.getSelectedProDomain();
  if (!_.isNull(domain)) {
    return domain.id;
  }
  return null;
}

function getApiUrl() {
  const apiVersionQueryParam = UrlUtils.getQueryParam('apiVersion');
  let apiUrl = Config.API_URL;

  // handle the 'apiVersion' query param, that allows to specify which api version we wants to use
  if (!_.isEmpty(apiVersionQueryParam)) {
    apiUrl = apiUrl.replace(/https:\/\/[\w-]*paymytable/, '');
    apiUrl = 'https://' + apiVersionQueryParam + '-dot-paymytable' + apiUrl;
  }

  return apiUrl;
}

export default {

  apiUrl: getApiUrl(),

  headersMiddleware: () => {
    return {
      'Authorization': getAuthorizationHeader(),
      'api-consumer': getApiKey(),
      'restaurant-id': RestaurantStore.getRestaurantId(),
      'pro-domain-id': getSelectedProDomainId(),
      'Accept-Language': I18n.getCurrentLanguageWithoutRegionCode(),
    }
  },

  errorMiddleware: (error, res) => {
    if (_.isNil(res)) {
      return false;
    }

    if (res.statusCode === 401) {
      console.error('[API] 401, redirect to login');

      SessionAction.logout();
      return true;
    }

    if (res.statusCode === 500) {
      Logger.error('API 500', res);
      RouteAction.redirect(RoutingEnum.SERVER_ERROR, null,
          {sessionId: res.headers['p-session-id'],});
      return true;
    }
  }

};



// WEBPACK FOOTER //
// ./scripts/constants/ApiManagerOptions.js